// Настраиваемый заголовок-герой над приложением «Сказки».
//
// Вариант выбирается по UTM-параметру со значением ver1 | ver2 | ver3.
// Если валидного UTM нет — на каждой загрузке страницы показывается случайный
// вариант (для A/B-теста копирайтинга).

export const HERO_VARIANTS = {
    ver1: {
        title: 'Самые тёплые вечера',
        titleHighlight: 'начинаются со сказки',
    },
    ver2: {
        title: 'Новая сказка каждый вечер',
        titleHighlight: 'никогда не надоедает',
    },
    ver3: {
        title: 'Уложи ребёнка спать за 5 минут —',
        titleHighlight: 'он уснёт быстро и спокойно',
    },
};

const VARIANT_KEYS = Object.keys(HERO_VARIANTS);

// UTM-параметры, в которых принимаем id варианта (по приоритету).
const UTM_KEYS = ['utm_content', 'utm_campaign', 'utm', 'ver'];

function variantKeyFromUtm(search) {
    const params = new URLSearchParams(search || '');
    for (const key of UTM_KEYS) {
        const raw = (params.get(key) || '').trim().toLowerCase();
        if (HERO_VARIANTS[raw]) return raw;
    }
    return null;
}

function randomVariantKey() {
    return VARIANT_KEYS[Math.floor(Math.random() * VARIANT_KEYS.length)];
}

// id активного варианта: закреплён UTM-ом, если он валиден, иначе случайный.
export function resolveHeroVariantKey(search = window.location.search) {
    return variantKeyFromUtm(search) || randomVariantKey();
}
